export function AdminFeedback({ feedback }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Feedback ({feedback.length})</h2>
      <div className="space-y-3">
        {feedback.map((f) => (
          <div key={f.id} className="bg-gray-800 rounded-xl p-4 space-y-2">
            <div className="flex justify-between text-sm text-gray-400">
              <span className="text-purple-400">{f.user_email}</span>
              <span>{new Date(f.created_at).toLocaleString('de-DE')}</span>
            </div>
            {f.category && (
              <span className={`inline-block text-[10px] font-medium rounded-full px-2 py-0.5 ${
                f.category === 'bug' ? 'bg-red-900/60 text-red-300' :
                f.category === 'idea' ? 'bg-blue-900/60 text-blue-300' :
                f.category === 'praise' ? 'bg-green-900/60 text-green-300' :
                'bg-gray-700 text-gray-300'
              }`}>
                {{ bug: 'Fehler', idea: 'Idee', praise: 'Lob', other: 'Sonstiges' }[f.category] || f.category}
              </span>
            )}
            {f.message && (
              <div>
                <div className="text-xs text-purple-300 font-medium">Nachricht</div>
                <div className="text-sm">{f.message}</div>
              </div>
            )}
            {f.what_worked && (
              <div>
                <div className="text-xs text-green-400 font-medium">Was hat gut funktioniert?</div>
                <div className="text-sm">{f.what_worked}</div>
              </div>
            )}
            {f.what_confused && (
              <div>
                <div className="text-xs text-yellow-400 font-medium">Was war verwirrend?</div>
                <div className="text-sm">{f.what_confused}</div>
              </div>
            )}
            {f.wishes && (
              <div>
                <div className="text-xs text-blue-400 font-medium">Wünsche</div>
                <div className="text-sm">{f.wishes}</div>
              </div>
            )}
            {f.general_feedback && (
              <div>
                <div className="text-xs text-gray-400 font-medium">Allgemein</div>
                <div className="text-sm">{f.general_feedback}</div>
              </div>
            )}
          </div>
        ))}
        {feedback.length === 0 && (
          <div className="text-gray-400">Noch kein Feedback</div>
        )}
      </div>
    </div>
  );
}
